// App.tsx
import './styles/globals.css';
import 'react-toastify/dist/ReactToastify.css';
import "./locale/i18n";
import { BrowserRouter } from 'react-router-dom';
import { KeycloakProvider } from './contexts/KeycloakContext';
import RouterApp from './routes';
import { useConfig } from './hooks/useConfig';
import { useEffect } from 'react';
import AppInitializer from './components/AppInitializer';

function App() {
  const { onChangeLocale } = useConfig()

  useEffect(() => {
    onChangeLocale("vn")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BrowserRouter>
      <KeycloakProvider>
        <AppInitializer>
          <RouterApp />
        </AppInitializer>
      </KeycloakProvider>
    </BrowserRouter>
  );
}

export default App;
